import type { SelectHTMLAttributes } from 'react';
import { clsx } from 'clsx';

export type SelectProps = SelectHTMLAttributes<HTMLSelectElement> & {
  options: { value: string; label: string }[];
};

export function Select({ options, className, ...rest }: SelectProps) {
  return (
    <select
      className={clsx(
        'h-9 appearance-none rounded-lg border border-form-input-border bg-form-input-background',
        'pl-3 pr-8 text-sm text-form-input-text outline-none',
        'bg-[url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'%235a6472\' stroke-width=\'2\' stroke-linecap=\'round\'%3E%3Cpath d=\'M6 9.5 12 15l6-5.5\'/%3E%3C/svg%3E")] bg-[length:14px] bg-[right_10px_center] bg-no-repeat',
        'transition-colors focus:border-form-input-border-selected',
        'disabled:cursor-not-allowed disabled:text-button-normal-disabled-text',
        className,
      )}
      {...rest}
    >
      {options.map(option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}
